function fn_comp_compare() {
        var $fn = $(".comp_compare");
        if ($fn.length) {
            $.getScript("//cdnjs.cloudflare.com/ajax/libs/mhayes-twentytwenty/2.0.0-beta.1/jquery.twentytwenty.min.js").done(function () {
                $fn.find(".twentytwenty-container").twentytwenty({
                    defaultOffsetPct: 0.4
                });
            });
        }
}